import { getGuidedModulesForRole } from './roleLearningMaps.js';

export function getLearningModuleForRoute(role, currentRoute, modalContext = null, learningCtx = {}) {
  if (!role || !currentRoute) return null;

  const modules = getGuidedModulesForRole(role);
  const routeKey = currentRoute.startsWith('/') ? currentRoute : `/${currentRoute}`;

  if (modalContext) {
    const { isModuleCompleted } = learningCtx;
    const modalModules = modules.filter(m => m.trigger === 'modal' && m.modalId === modalContext && m.route === routeKey);
    const incomplete = isModuleCompleted
      ? modalModules.find(m => !isModuleCompleted(m.moduleId))
      : modalModules[0];
    return incomplete || modalModules[0] || null;
  }

  if (learningCtx.schedulingDrawerOpen) {
    const drawerModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'schedulingDrawerOpen' && m.route === routeKey);
    if (drawerModule) return drawerModule;
  }

  if (learningCtx.schedulingTabScheduled) {
    const scheduledModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'schedulingTabScheduled' && m.route === routeKey);
    if (scheduledModule) return scheduledModule;
  }

  if (learningCtx.specialistUnreconciledDrawer) {
    const unreconciledModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistUnreconciledDrawer' && m.route === routeKey);
    if (unreconciledModule) return unreconciledModule;
  }

  if (learningCtx.specialistClosingDrawer) {
    const closingModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistClosingDrawer' && m.route === routeKey);
    if (closingModule) return closingModule;
  }

  if (learningCtx.specialistAdminClosingDrawer) {
    const adminClosingModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistAdminClosingDrawer' && m.route === routeKey);
    if (adminClosingModule) return adminClosingModule;
  }

  if (learningCtx.specialistAdminTodayTab) {
    const adminTodayModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistAdminTodayTab' && m.route === routeKey);
    if (adminTodayModule) return adminTodayModule;
  }

  if (learningCtx.specialistAdminNeedsCloseLoopTab) {
    const adminNeedsCloseModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistAdminNeedsCloseLoopTab' && m.route === routeKey);
    if (adminNeedsCloseModule) return adminNeedsCloseModule;
  }

  if (learningCtx.specialistAdminClosedLoopTab) {
    const adminClosedLoopModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistAdminClosedLoopTab' && m.route === routeKey);
    if (adminClosedLoopModule) return adminClosedLoopModule;
  }

  if (learningCtx.specialistAdminQueueHealth) {
    const queueHealthModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistAdminQueueHealth' && m.route === routeKey);
    if (queueHealthModule) return queueHealthModule;
  }

  if (learningCtx.specialistTodayDrawer) {
    const todayDrawerModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistTodayDrawer' && m.route === routeKey);
    if (todayDrawerModule) return todayDrawerModule;
  }

  if (learningCtx.specialistTabToday) {
    const todayModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistTabToday' && m.route === routeKey);
    if (todayModule) return todayModule;
  }

  if (learningCtx.specialistTabUpcoming) {
    const upcomingModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistTabUpcoming' && m.route === routeKey);
    if (upcomingModule) return upcomingModule;
  }

  if (learningCtx.specialistTabNeedsAction) {
    const needsActionModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistTabNeedsAction' && m.route === routeKey);
    if (needsActionModule) return needsActionModule;
  }

  if (learningCtx.packBuilderList) {
    const packListModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'packBuilderList' && m.route === routeKey);
    if (packListModule) return packListModule;
  }

  if (learningCtx.packEditorOpen) {
    const packEditorModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'packEditorOpen' && m.route === routeKey);
    if (packEditorModule) return packEditorModule;
  }

  if (learningCtx.specialistTabClosedReferrals) {
    const closedModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'specialistTabClosedReferrals' && m.route === routeKey);
    if (closedModule) return closedModule;
  }

  if (learningCtx.isSubmitted) {
    const submittedModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'submittedPhase' && m.route === routeKey);
    if (submittedModule) return submittedModule;
    return null;
  }

  const hasResumeContext = learningCtx.isResuming
    || (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('resumeReferral'));
  if (hasResumeContext) {
    const contextModule = modules.find(m => m.trigger === 'context' && m.contextKey === 'resumeReferral' && m.route === routeKey);
    if (contextModule) return contextModule;
    // No resume-specific module for THIS route (e.g. arriving at the Not Yet Inbox
    // with a lingering resume context). Fall through to the normal route module
    // instead of suppressing it — the resume context only owns the Gate route.
  }

  const { isModuleCompleted: isCompleted } = learningCtx;
  const routeModules = modules.filter(m => m.route === routeKey && m.trigger !== 'modal' && m.trigger !== 'context');
  if (isCompleted) {
    const incomplete = routeModules.find(m => !isCompleted(m.moduleId));
    if (incomplete) return incomplete;
  }
  return routeModules[0] || null;
}
